import { Injectable, signal, computed } from '@angular/core';

/**
 * Central service holding the viewer instance as an Angular signal.
 */
@Injectable({ providedIn: 'root' })
export class ViewerCoreService {
  /** The viewer instance signal – set once during initialization, cleared on dispose. */
  private readonly _viewer = signal<any | null>(null);

  /** Read-only signal for the viewer instance. */
  readonly viewer = this._viewer.asReadonly();

  /** Computed signal indicating whether the viewer is ready. */
  readonly isReady = computed(() => this._viewer() != null);

  /**
   * Register the viewer instance. Called by ViewerService after construction.
   */
  setViewer(viewer: any): void {
    this._viewer.set(viewer);
  }

  /**
   * Clear the viewer instance. Called on dispose.
   */
  clearViewer(): void {
    this._viewer.set(null);
  }
}
